import Masonry from "masonry-layout";

document.addEventListener("DOMContentLoaded", function () {
    const container = '.massonry-grid';
    const containerEl = document.querySelector(container)
    if(containerEl) {
        new Masonry( containerEl, {
            itemSelector: '.massonry-item',
            gutter:20,
            originLeft:true
        });

    }
});